import React, {useMemo} from "react";
import PropTypes from 'prop-types'
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import {uid} from "react-uid";
import {Divider, Icon, IconButton, Tooltip} from "@material-ui/core";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import Events from "../../../ScreenDesigner/ToolBar/Panels/Events";

const useStyles = makeStyles(() => ({
    title: {
        width: '90px',
        paddingTop: 10
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        padding: 10
    },
    endPointsContainer: {
        width: 'calc(100% - 100px)'
    },
    tableHeader: {
        background: 'rgb(237, 237, 237)',
        minHeight: 38.5,
        display: 'flex',
        alignItems: 'center'
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        '& $createEventButton': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $createEventButton': {
                visibility: 'visible'
            }
        }
    },
    cell: {
        padding: "6px 24px 6px 16px"
    },
    bodyCell: {
        padding: "2px 24px 2px 16px",
    },
    createEventButton: {}
}));
const headCells = [
    {name: 'name', label: "Name", width: 200},
    {name: 'description', label: "Description"},
];
const emptyEvent = {event: '', actions: [{}]}

const Endpoints = ({
                       endpoints,
                       inheritedEndpoints,
                       onChangeItem,
                       onChangeAll,
                       createEndpointEvent,
                       removeEndpointEvent
                   }) => {
    return (
        <RenderData
            onChangeAll={onChangeAll}
            onChangeItem={onChangeItem}
            removeEndpointEvent={removeEndpointEvent}
            createEndpointEvent={createEndpointEvent}
            data={endpoints.length ? endpoints : inheritedEndpoints}
            disabled={!Boolean(endpoints.length)}
            title={'Endpoints'}
            basePath={'endPoints'}
        />
    )
};
export default Endpoints

Endpoints.propTypes = {
    endpoints: PropTypes.array,
    inheritedEndpoints: PropTypes.array,
    onChangeItem: PropTypes.func,
    onChangeAll: PropTypes.func
};


const RenderData = ({
                        data = [],
                        title,
                        onChangeAll,
                        basePath,
                        disabled,
                        onChangeItem,
                        createEndpointEvent,
                        removeEndpointEvent
                    }) => {
    const classes = useStyles();
    const countSelected = useMemo(() => {
        return data.reduce((acc, value) => {
            return value.active ? acc + 1 : acc
        }, 0);
    }, [JSON.stringify(data)])
    const countRows = useMemo(() => {
        return data.length;
    }, [data.length])

    return (
        <div className={classes.container}>
            <div className={classes.title}>
                <Typography color={"textSecondary"} style={{fontSize: '0.9rem'}}>{title}</Typography>
            </div>
            <div className={classes.endPointsContainer}>
                <div className={classes.tableHeader}>
                    <div style={{width: 40}} className={classes.cell}>
                        <Checkbox
                            indeterminate={countSelected > 0 && countSelected < countRows}
                            checked={countRows === countSelected && countRows !== 0}
                            disabled={!Boolean(countRows) || disabled}
                            onChange={(e) => onChangeAll(e.target.checked, basePath)}
                            style={{padding: '1px'}}
                            color={"primary"}
                        />
                    </div>
                    {headCells.map(headCell => {
                        return <div className={classes.cell} key={headCell.name}
                                    style={{width: headCell.width}}>{headCell.label}</div>
                    })}
                </div>
                <div>
                    {data.map((item, index) => {
                        const hasEvents = Boolean(item.events && item.events.length);
                        return (
                            <>
                                <div className={classes.row} key={index}>
                                    <div style={{width: 40}} className={classes.bodyCell}>
                                        <Checkbox
                                            disabled={!Boolean(countRows) || disabled}
                                            checked={item.active}
                                            onChange={() => onChangeItem(!item.active, `${basePath}.${index}.active`)}
                                            color={"primary"}
                                            style={{padding: '2px'}}
                                        />
                                    </div>
                                    {headCells.map(cell => {
                                        return <div className={classes.bodyCell}
                                                    style={{width: cell.width || 'calc(100% - 265px)'}}
                                                    key={uid(cell)}>{item[cell.name]}</div>
                                    })}

                                    {!hasEvents && (<div className={classes.createEventButton}>
                                        <Tooltip title={'Create event'} onClick={() => {
                                            createEndpointEvent(emptyEvent, `endPoints.${index}.events`, 0)
                                        }}>
                                            <IconButton size={"small"}>
                                                <Icon fontSize={"small"}>add_outlined</Icon>
                                            </IconButton>
                                        </Tooltip>
                                    </div>)}

                                </div>
                                {hasEvents && <EndpointEvents data={item.events} onChangeItem={onChangeItem}
                                                              index={index}
                                                              createEndpointEvent={createEndpointEvent}
                                                              removeEndpointEvent={removeEndpointEvent}
                                />}
                                {!hasEvents && <Divider/>}
                            </>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

const EndpointEvents = ({data = [], onChangeItem, index: endpointIndex, createEndpointEvent, removeEndpointEvent}) => {
    const classes = useStyles();
    const path = '';


    function createEvent(index) {
        createEndpointEvent(emptyEvent, `endPoints.${endpointIndex}.events`, index)
    }

    function removeEvent(path, index) {
        removeEndpointEvent(`endPoints.${endpointIndex}.events.${index}`)
    }

    function saveAction(values, path) {
        onChangeItem(values, `endPoints.${endpointIndex}.${path}`)
    }

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <div style={{width: 40}}/>
            <div style={{width: 200}} className={classes.bodyCell}>Events</div>
            <div style={{width: 'calc(100% - 240px'}} className={classes.bodyCell}>
                <ScreenDesignerContextNew.Provider value={{
                    screenValues: {
                        ...data,
                        otherComponents: []
                    },
                    currentCustomResolution: 'desktop',
                    listStorage: [],
                    openListDesigner: {open: false},
                    selectedComponent: {
                        path,
                        component: {
                            type: 'endpoint',
                            events: data
                        }
                    },
                    // onChangeDefaultFields: onChangeMenuItemProps,
                    createEvent,
                    removeEvent: (index) => removeEvent(path, index),
                    onChangeEventComponent: (v, p) => saveAction(v, 'events' + '.' + p),
                    actionSave: (eventIndex, actions) => saveAction(actions, `events.${eventIndex}.actions`)
                }}>
                    <Events/>
                </ScreenDesignerContextNew.Provider>
            </div>
        </div>
    )
}